import { CalendarIcon, NotificationBellIcon, UserIcon } from '../../../assets/svg';

export const EMPLOYEE_ACCOUNT_PANEL_OPTIONS_MENU = [
  {
    icon: UserIcon,
    title: 'Personal Details',
    handlerId: 'viewPersonalDetails',
  },
  {
    icon: CalendarIcon,
    title: 'Shifts',
    handlerId: 'viewShifts',
  },
  {
    icon: NotificationBellIcon,
    title: 'Availability',
    handlerId: 'viewAvailability',
  },
];
